import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GalaxyFilterValueInterface } from '../interface';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'glxy-no-input-filter-input',
  template: ``,
  providers: [],
  imports: [CommonModule],
})
export class GalaxyNoInputFilterInputComponent {
  @Input() set initialValue(_: GalaxyFilterValueInterface[]) {
    this.valueChanges.emit([]);
  }
  @Output() valueChanges = new EventEmitter<GalaxyFilterValueInterface[]>();
}
